/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingInfoDto } from './booking-info-dto';
import {
    BookingInfoDtoFromJSON,
    BookingInfoDtoFromJSONTyped,
    BookingInfoDtoToJSON,
    BookingInfoDtoToJSONTyped,
} from './booking-info-dto';
import type { PreorderPropertyInfoDto } from './preorder-property-info-dto';
import {
    PreorderPropertyInfoDtoFromJSON,
    PreorderPropertyInfoDtoFromJSONTyped,
    PreorderPropertyInfoDtoToJSON,
    PreorderPropertyInfoDtoToJSONTyped,
} from './preorder-property-info-dto';
import type { AdditionalServiceInfoDto } from './additional-service-info-dto';
import {
    AdditionalServiceInfoDtoFromJSON,
    AdditionalServiceInfoDtoFromJSONTyped,
    AdditionalServiceInfoDtoToJSON,
    AdditionalServiceInfoDtoToJSONTyped,
} from './additional-service-info-dto';
import type { FinalOrderRoomInfoDto } from './final-order-room-info-dto';
import {
    FinalOrderRoomInfoDtoFromJSON,
    FinalOrderRoomInfoDtoFromJSONTyped,
    FinalOrderRoomInfoDtoToJSON,
    FinalOrderRoomInfoDtoToJSONTyped,
} from './final-order-room-info-dto';
import type { PersonInfoDto } from './person-info-dto';
import {
    PersonInfoDtoFromJSON,
    PersonInfoDtoFromJSONTyped,
    PersonInfoDtoToJSON,
    PersonInfoDtoToJSONTyped,
} from './person-info-dto';

/**
 * 
 * @export
 * @interface OrderInfoDto
 */
export interface OrderInfoDto {
    /**
     * Order ID
     * @type {string}
     * @memberof OrderInfoDto
     */
    id: string;
    /**
     * Order number
     * @type {string}
     * @memberof OrderInfoDto
     */
    orderNumber: string;
    /**
     * 
     * @type {PreorderPropertyInfoDto}
     * @memberof OrderInfoDto
     */
    propertyInfo: PreorderPropertyInfoDto;
    /**
     * 
     * @type {BookingInfoDto}
     * @memberof OrderInfoDto
     */
    bookingInfo: BookingInfoDto;
    /**
     * 
     * @type {FinalOrderRoomInfoDto}
     * @memberof OrderInfoDto
     */
    roomInfo: FinalOrderRoomInfoDto;
    /**
     * 
     * @type {Array<PersonInfoDto>}
     * @memberof OrderInfoDto
     */
    personInfo?: Array<PersonInfoDto>;
    /**
     * 
     * @type {Array<AdditionalServiceInfoDto>}
     * @memberof OrderInfoDto
     */
    additionalServices: Array<AdditionalServiceInfoDto>;
}

/**
 * Check if a given object implements the OrderInfoDto interface.
 */
export function instanceOfOrderInfoDto(value: object): value is OrderInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('orderNumber' in value) || value['orderNumber'] === undefined) return false;
    if (!('propertyInfo' in value) || value['propertyInfo'] === undefined) return false;
    if (!('bookingInfo' in value) || value['bookingInfo'] === undefined) return false;
    if (!('roomInfo' in value) || value['roomInfo'] === undefined) return false;
    if (!('additionalServices' in value) || value['additionalServices'] === undefined) return false;
    return true;
}

export function OrderInfoDtoFromJSON(json: any): OrderInfoDto {
    return OrderInfoDtoFromJSONTyped(json, false);
}

export function OrderInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderNumber': json['orderNumber'],
        'propertyInfo': PreorderPropertyInfoDtoFromJSON(json['propertyInfo']),
        'bookingInfo': BookingInfoDtoFromJSON(json['bookingInfo']),
        'roomInfo': FinalOrderRoomInfoDtoFromJSON(json['roomInfo']),
        'personInfo': json['personInfo'] == null ? undefined : ((json['personInfo'] as Array<any>).map(PersonInfoDtoFromJSON)),
        'additionalServices': ((json['additionalServices'] as Array<any>).map(AdditionalServiceInfoDtoFromJSON)),
    };
}

  export function OrderInfoDtoToJSON(json: any): OrderInfoDto {
      return OrderInfoDtoToJSONTyped(json, false);
  }

  export function OrderInfoDtoToJSONTyped(value?: OrderInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderNumber': value['orderNumber'],
        'propertyInfo': PreorderPropertyInfoDtoToJSON(value['propertyInfo']),
        'bookingInfo': BookingInfoDtoToJSON(value['bookingInfo']),
        'roomInfo': FinalOrderRoomInfoDtoToJSON(value['roomInfo']),
        'personInfo': value['personInfo'] == null ? undefined : ((value['personInfo'] as Array<any>).map(PersonInfoDtoToJSON)),
        'additionalServices': ((value['additionalServices'] as Array<any>).map(AdditionalServiceInfoDtoToJSON)),
    };
}

